'use client';

import cn from "classnames";
import { motion } from "framer-motion";
import { Text } from "../Text";

export type CalloutProps = {
  title: string;
  description: string;
  backgroundLevel?: 'l1' | 'l2';
}

const pulseAnimationVariants = {
  initial: { boxShadow: '0 0 1px 1px #DEE948' },
  animate: { boxShadow: '0 0 4px 4px #DEE948' },
}

const backgroundClasses = {
  'l1': {
    callout: 'surface-l1',
    pulse: 'surface-l2',
  },
  'l2': {
    callout: 'surface-l2',
    pulse: 'surface-l3',
  },
}

const PulseAnimation = ({ backgroundLevel }: { backgroundLevel: CalloutProps['backgroundLevel'] }) => {
  return (
    <div className={cn("w-2 h-2 rounded-8 p-[6px] overflow-hidden", backgroundClasses[backgroundLevel ?? 'l2'].pulse)}>
      <motion.div
        className="w-[4px] h-[4px] surface-highlight rounded-4 m-auto"
        variants={pulseAnimationVariants}
        initial="initial"
        animate="animate"
        transition={{ duration: 0.75, ease: 'linear', repeat: Infinity, repeatType: 'reverse' }}
      />
    </div>
  );
}

export const Callout = ({ title, description, backgroundLevel = 'l1' }: CalloutProps) => {
  return (
    <div className={cn("flex flex-col p-md gap-y-2xs rounded-8", backgroundClasses[backgroundLevel ?? 'l1'].callout)}>
      <div className="flex gap-2xs items-center">
        <PulseAnimation backgroundLevel={backgroundLevel} />
        <Text type="micro1" className="text-primary">{title}</Text>
      </div>
      <Text type="p2-medium" className="text-primary">{description}</Text>
    </div>
  );
};
